export default {
    body: '',
    loaded: false,
    size: 0,
    useEmbeddedCustomFonts: false,
};
